import { getApiClient, initializeApiClient } from "../../apiService";

export const AddAdvertising = async (
  mP_MR_ItemId,
  itemNameAnother,
  descriptionContentObjective,
  quantity,
  mediaAndAdvertisingPlanExplanation,

  aP_AdvertisingAndMediaPlanId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/MP_MarketingResourcesAndPublications/AddMP_MarketingResourcesAndPublicationsData`,
    {
      mP_MR_ItemId: mP_MR_ItemId,
      itemNameAnother: itemNameAnother,
      descriptionContentObjective: descriptionContentObjective,
      quantity: quantity,
      mediaAndAdvertisingPlanExplanation: mediaAndAdvertisingPlanExplanation,

      aP_AdvertisingAndMediaPlanId: aP_AdvertisingAndMediaPlanId,
    }
  );

  return response;
};

export default AddAdvertising;
